import { Card, CardContent, Typography } from "@mui/material";

export function DashboardStat(params: { title: string, data: number, color: string }) {

    return <>
            <Card sx={{ maxHeight: 200 }}>
                <CardContent>
                    <Typography
                        sx={{ fontSize: 50 }}
                        color={params.color}
                    >
                        {params.data}
                    </Typography>
                    <Typography sx={{ fontSize: 16, fontWeight: 'bold' }} gutterBottom>
                        {params.title}
                    </Typography>
                </CardContent>
            </Card>
    </>
}